import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "pep-text" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "section-text" }, "*PEP"),
  /*#__PURE__*/_createTextVNode(" es la Persona Expuesta Políticamente, iIgualmente se catalogan como PEP las personas que tengan una sociedad conyugal, de hecho, o derecho con las personas expuestas políticamente nacionales o extranjeras, así como a sus familiares hasta el segundo grado de consanguinidad, segundo de afinidad y primero civil. ")
], -1)
const _hoisted_2 = { class: "pep" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"62px"} }, null, -1)
const _hoisted_4 = { style: {"height":"62px"} }
const _hoisted_5 = { style: {"height":"62px"} }
const _hoisted_6 = { style: {"height":"62px"} }
const _hoisted_7 = { style: {"height":"62px"} }
const _hoisted_8 = { style: {"height":"62px"} }
const _hoisted_9 = { style: {"height":"62px"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"62px"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_row, { gutter: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 22 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table, {
                  height: "300",
                  data: _ctx.objetoInfoBeneficiarioAccionista_Juridico.Beneficiario,
                  span: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, { width: "20%" }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("span", null, [
                          _createElementVNode("b", null, _toDisplayString(scope.$index + 1), 1)
                        ]),
                        _hoisted_3
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      class: "section-text-color",
                      label: "Nombre o razón social de accionista*",
                      width: "245px;"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_input, {
                          type: "text",
                          modelValue: scope.row.NombreAJ_Beneficiario,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.NombreAJ_Beneficiario) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _withDirectives(_createElementVNode("div", _hoisted_4, null, 512), [
                          [_vShow, !_ctx.validacionInfoBeneficiarioAccionista_Juridico.Beneficiario.$each.$response.$errors[scope.$index].NombreAJ_Beneficiario.length]
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionInfoBeneficiarioAccionista_Juridico.Beneficiario.$each.$response.$errors[scope.$index].NombreAJ_Beneficiario, (error) => {
                          return (_openBlock(), _createBlock(_component_el_form_item, {
                            key: error,
                            class: "section-error-message"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(error.$message), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      class: "section-text-color",
                      label: "Nombre de beneficiario*",
                      width: "200px;"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_input, {
                          type: "text",
                          modelValue: scope.row.NombreBeneficiario,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.NombreBeneficiario) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _withDirectives(_createElementVNode("div", _hoisted_5, null, 512), [
                          [_vShow, !_ctx.validacionInfoBeneficiarioAccionista_Juridico.Beneficiario.$each.$response.$errors[scope.$index].NombreBeneficiario.length]
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionInfoBeneficiarioAccionista_Juridico.Beneficiario.$each.$response.$errors[scope.$index].NombreBeneficiario, (error) => {
                          return (_openBlock(), _createBlock(_component_el_form_item, {
                            key: error,
                            class: "section-error-message"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(error.$message), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Tipo ID*",
                      width: "140px;"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_select, {
                          modelValue: scope.row.TipoIdBeneficiario,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.TipoIdBeneficiario) = $event),
                          placeholder: "Seleccionar"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.tipoDeIdentificacion, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.codigo,
                                label: item.valor,
                                value: item.valor
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue"]),
                        _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [
                          [_vShow, !_ctx.validacionInfoBeneficiarioAccionista_Juridico.Beneficiario.$each.$response.$errors[scope.$index].TipoIdBeneficiario.length]
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionInfoBeneficiarioAccionista_Juridico.Beneficiario.$each.$response.$errors[scope.$index].TipoIdBeneficiario, (error) => {
                          return (_openBlock(), _createBlock(_component_el_form_item, {
                            key: error,
                            class: "section-error-message"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(error.$message), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "N° ID*",
                      width: "150px;"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_input, {
                          type: "text",
                          modelValue: scope.row.NumeroIdentificacionBeneficiario,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.NumeroIdentificacionBeneficiario) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _withDirectives(_createElementVNode("div", _hoisted_7, null, 512), [
                          [_vShow, !_ctx.validacionInfoBeneficiarioAccionista_Juridico.Beneficiario.$each.$response.$errors[scope.$index].NumeroIdentificacionBeneficiario.length]
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionInfoBeneficiarioAccionista_Juridico.Beneficiario.$each.$response.$errors[scope.$index].NumeroIdentificacionBeneficiario, (error) => {
                          return (_openBlock(), _createBlock(_component_el_form_item, {
                            key: error,
                            class: "section-error-message"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(error.$message), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "¿Es PEP?*",
                      width: "130px;"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_select, {
                          modelValue: scope.row.EsPEPBeneficiario,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.EsPEPBeneficiario) = $event),
                          placeholder: "Seleccionar",
                          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ValidaSiPEPAJ()))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.generico, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.codigo,
                                label: item.valor,
                                value: item.valor
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue"]),
                        _withDirectives(_createElementVNode("div", _hoisted_8, null, 512), [
                          [_vShow, !_ctx.validacionInfoBeneficiarioAccionista_Juridico.Beneficiario.$each.$response.$errors[scope.$index].EsPEPBeneficiario.length]
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionInfoBeneficiarioAccionista_Juridico.Beneficiario.$each.$response.$errors[scope.$index].EsPEPBeneficiario, (error) => {
                          return (_openBlock(), _createBlock(_component_el_form_item, {
                            key: error,
                            class: "section-error-message"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(error.$message), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "¿Tiene vínculos familiares con PEP?*",
                      width: "170px;"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_select, {
                          modelValue: scope.row.VinculosFamPEP_Beneficiario,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.VinculosFamPEP_Beneficiario) = $event),
                          placeholder: "Seleccionar",
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ValidaSiPEPAJ()))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.generico, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.codigo,
                                label: item.valor,
                                value: item.valor
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue"]),
                        _withDirectives(_createElementVNode("div", _hoisted_9, null, 512), [
                          [_vShow, !_ctx.validacionInfoBeneficiarioAccionista_Juridico.Beneficiario.$each.$response.$errors[scope.$index].VinculosFamPEP_Beneficiario.length]
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionInfoBeneficiarioAccionista_Juridico.Beneficiario.$each.$response.$errors[scope.$index].VinculosFamPEP_Beneficiario, (error) => {
                          return (_openBlock(), _createBlock(_component_el_form_item, {
                            key: error,
                            class: "section-error-message"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(error.$message), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, { width: "50" }, {
                      default: _withCtx((scope) => [
                        (scope.$index > 0)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              circle: "",
                              class: "dinamic-form-button",
                              size: "small",
                              type: "success",
                              icon: "el-icon-minus",
                              onClick: ($event: any) => {_ctx.EliminarFilaBeneficiario(scope.$index);_ctx.ValidaSiPEPAJ();}
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        _hoisted_10
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  circle: "",
                  class: "dinamic-form-button",
                  size: "small",
                  type: "success",
                  icon: "el-icon-plus",
                  onClick: _ctx.AgregarFilaBeneficiario
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}